/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Error_Files_RequiredInputs */

const vi_media_error_files_required = /** @type {(inputs: Media_Error_Files_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có file nào được gửi lên. Hãy chọn ít nhất một ảnh hoặc video.`)
};

/**

* @param {Media_Error_Files_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_error_files_required = /** @type {((inputs?: Media_Error_Files_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Error_Files_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_error_files_required(inputs)
});